import { useState, useEffect } from "react";
import {
  IconButton,
  InputAdornment,
  makeStyles,
  Modal,
} from "@material-ui/core";
import { FormikHelpers, useFormik } from "formik";
import * as Yup from "yup";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Alert from "@material-ui/lab/Alert";
import { useIntl } from "react-intl";
import { FormattedMessage } from "react-intl";
import { InputField } from "../../../../../components/input-field/InputField";
import { InputButton } from "../../../../../components/input-button/InputButton";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import IcipWithdrawTarificationService from "../../../../../services/IcipWithdrawTarificationService";
import IcipWithdrawTafification from "../../../../../models/IcipWithdrawTarification";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CurrencyService from "../../../../../services/CurrencyService";
import Pricing from "../../../../../models/Pricing";
import PricingService from "../../../../../services/PricingService";
import PricingGroupService from "../../../../../services/PricingGroupService";
import CountryService from "../../../../../services/CountryService";
import { Autocomplete } from "@material-ui/lab";
import BaseAccountConfiguration from "../../../../../models/BaseAccountConfiguration";
import BaseAccountConfigurationService from "../../../../../services/BaseAccountConfigurationService";
import { InputDate } from "../../../../../components/input-date/InputDate";
import moment from "moment";
import { CalendarToday } from "@material-ui/icons";

interface EditBaseAccountConfProps {
  closeCallback: () => void;
  onSubmitCallback: () => void;
  isOpened: boolean;
  currencies: any[];
  countries: any[];
  pricingGroups: any[];
  baseAccountConf: BaseAccountConfiguration;
}

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: "bold",
  },
  modalBody: {
    width: 700,
    padding: 10,
    border: "none",
  },
  searchGroup: {
    display: "inline-flex",
  },
  testField: {
    margin: 2,
    height: 50,
  },
  testField1: {
    height: 35,
    margin: 5,
    marginTop: 30,
  },
  addBox: {
    padding: 5,
  },
  creditBaseField: {
    height: 40,
  },
  searchAuto: {
    //border: '1px outset lightgray',
  },

  antPickerDropdown: {
    zIndex: 100000,
  },
}));

export const EditBaseAccountConf = (props: EditBaseAccountConfProps) => {
  const classes = useStyles();
  const intl = useIntl();
  const { formatMessage } = useIntl();
  const { baseAccountConf, closeCallback, onSubmitCallback } = props;
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [succeed, setSucceed] = useState(false);
  const [currencies, setcurrencies] = useState(props.currencies);
  const [currentBaseAccountConf, setCurrentBaseAccountConf] = useState(
    props.baseAccountConf
  );
  const [updatedBaseAccountConf, setUpdatedBaseAccountConf] = useState({});
  const [currenciesObjet, setCurrenciesObjet] = useState([]);
  const [pricingGroups, setPricingGroups] = useState([]);
  const [countries, setCountries] = useState([]);

  const formik = useFormik({
    initialValues: {
      credit_base: baseAccountConf.credit_base,
      assignment_date: baseAccountConf.assignment_date,
      pricing_group_id: baseAccountConf.pricing_group.id,
      currency_id: baseAccountConf.currency.id,
      country_id: baseAccountConf.country.id,
    },
    validationSchema: Yup.object().shape({
      credit_base: Yup.number().required(
        formatMessage({ id: "sharedScreen.pleaseEnterCreditBase" })
      ),
      assignment_date: Yup.string().required(
        formatMessage({ id: "sharedScreen.pleaseEnterAssignmentDate" })
      ),
      pricing_group_id: Yup.number().required(
        formatMessage({ id: "sharedScreen.pleaseEnterPricingGroup" })
      ),
      currency_id: Yup.number().required(
        formatMessage({ id: "sharedScreen.pleaseEnterCurrency" })
      ),
      country_id: Yup.number().required(
        formatMessage({ id: "sharedScreen.pleaseEnterCountry" })
      ),
    }),
    onSubmit: async (
      values,
      { setSubmitting, resetForm }: FormikHelpers<any>
    ) => {
      setError(false);
      console.log(values);
      console.log(currentBaseAccountConf);
      try {
        const updateBaseAccountConfResult = await BaseAccountConfigurationService.updateBaseAccountConf(
          currentBaseAccountConf.id,
          currentBaseAccountConf
        );
        if (
          updateBaseAccountConfResult.isSuccess &&
          updateBaseAccountConfResult.data.code === 100
        ) {
          resetForm({});
          setSucceed(true);
          setTimeout(() => {
            setSucceed(false);
          }, 2000);
          setUpdatedBaseAccountConf(updateBaseAccountConfResult);
          onSubmitCallback();
        } else {
          setError(true);
          if (updateBaseAccountConfResult.data.code === 101) {
            setErrorMessage("Similar base account configuration already exist");
          } else {
            setErrorMessage("");
          }
        }
      } catch (error) {
        setError(true);
      }
      setSubmitting(false);
    },
  });

  const handleDataChange = (name: string, value: string) => {
    let currBaseAccountConf = { ...currentBaseAccountConf };
    currBaseAccountConf[name] = value;

    setCurrentBaseAccountConf(currBaseAccountConf);
  };

  //Load pricing group
  const loadPricingGroups = () => {
    const response = PricingGroupService.getAllPricingGroup();
    response.then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        let pg = JSON.parse(JSON.stringify(response.data.data));
        setPricingGroups(pg);
      } else {
        setPricingGroups(pricingGroups);
      }
    });
  };

  //Load country
  const loadCountries = () => {
    const response = CountryService.supportedCountries();
    response.then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        let countries = JSON.parse(JSON.stringify(response.data.data));
        setCountries(countries);
      } else {
        setCountries(countries);
      }
    });
  };

  const loadCurrenciesList = () => {
    CurrencyService.supportedCurrencies().then((response) => {
      if (response.isSuccess) {
        switch (response.data.code) {
          case 100:
            const currenciesResults = JSON.parse(
              JSON.stringify(response.data.data)
            );
            setCurrenciesObjet(currenciesResults);
            break;
          case 110:
            setError(true);
            break;
        }
      } else {
        setError(true);
      }
    });
  };

  useEffect(() => {
    loadCurrenciesList();
    loadPricingGroups();
    loadCountries();
    setCurrentBaseAccountConf(props.baseAccountConf);
  }, [baseAccountConf]);

  const handleDateChange = (name: string, dateString: string) => {
    formik.setValues({ ...formik.values, [name]: dateString });

    let currBaseAccountConf = { ...currentBaseAccountConf };
    currBaseAccountConf[name] = dateString;

    setCurrentBaseAccountConf(currBaseAccountConf);
  };

  const handleClose = (e) => {
    closeCallback();
  };
  return (
    <>
      <Paper className={classes.modalBody}>
        <form
          noValidate
          onSubmit={formik.handleSubmit}
          autoComplete="off"
          method={"post"}
        >
          <Grid spacing={2}>
            <Grid
              item
              container
              direction="row"
              justify="space-between"
              alignItems="center"
              xs={12}
              sm={12}
              lg={12}
            >
              <Typography
                className={classes.modalTitle}
                variant="h4"
                component="h4"
              >
                <FormattedMessage id="sharedScreen.editBaseAccountConfTitle" />
              </Typography>
              <IconButton edge="end" onClick={(e) => handleClose(e)}>
                <HighlightOffIcon fontSize="large" />
              </IconButton>
            </Grid>
            <Grid
              item
              container
              direction="row"
              justify="space-between"
              alignItems="center"
              xs={12}
              sm={12}
              lg={12}
            ></Grid>
            {error && (
              <Grid item xs={12} sm={12} lg={12}>
                <Alert severity="error">
                  {errorMessage === "" && (
                    <FormattedMessage id="sharedScreen.thereWasAProblemEditBaseAccountConf" />
                  )}
                  {errorMessage !== "" && <p>{errorMessage}</p>}
                </Alert>
              </Grid>
            )}
            <Grid item xs={12} sm={12} lg={12} className={classes.addBox}>
              <Grid item xs={12} sm={12} lg={12} className={classes.addBox}>
                <InputField
                  className={classes.creditBaseField}
                  value={currentBaseAccountConf.credit_base}
                  type="number"
                  fullWidth
                  label={formatMessage({ id: "sharedScreen.creditBase" })}
                  placeholder={formatMessage({ id: "sharedScreen.creditBase" })}
                  name="credit_base"
                  onChange={(event) =>
                    handleDataChange(event.target.name, event.target.value)
                  }
                  error={
                    formik.touched.credit_base &&
                    Boolean(formik.errors.credit_base)
                  }
                  helperText={
                    formik.touched.credit_base && formik.errors.credit_base
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12} className={classes.addBox}>
                <InputDate
                  minDate={moment()
                    .subtract("year", 2)
                    .format("YYYY-MM-DD HH:mm:ss")}
                  onDateChange={(name, date) => handleDateChange(name, date)}
                  inputProps={{
                    disabled: formik.isSubmitting,
                    fullWidth: true,
                    id: "assignment_date",
                    style: { height: 40 },
                    name: "assignment_date",
                    label: intl.formatMessage({
                      id: "sharedScreen.assignmentDate",
                    }),
                    placeholder: intl.formatMessage({
                      id: "sharedScreen.assignmentDate",
                    }),
                    endAdornment: (
                      <InputAdornment position="start">
                        <CalendarToday />
                      </InputAdornment>
                    ),
                    value: `${currentBaseAccountConf.assignment_date}`,
                    error:
                      Boolean(formik.touched.assignment_date) &&
                      Boolean(formik.errors.assignment_date),
                    helperText:
                      formik.touched.assignment_date &&
                      formik.errors.assignment_date,
                  }}
                  pickerProps={{
                    format: "YYYY-MM-DD HH:mm:ss",
                    disabled: false,
                    showToday: false,
                    showTime: true,
                  }}
                />
              </Grid>

              {/*<Grid item xs={12} sm={12} lg={12} className={classes.addBox}>
                  <InputField
                    value={currentBaseAccountConf.assignment_date}
                    type="date"
                    fullWidth
                    label={formatMessage({ id: "sharedScreen.assignmentDate" })}
                    placeholder={formatMessage({ id: "sharedScreen.assignmentDate" })}
                    name="assignment_date"
                    //onChange={formik.handleChange}
                    onChange={(event) =>
                      handleDataChange(event.target.name, event.target.value)
                    }
                    error={
                      formik.touched.assignment_date && Boolean(formik.errors.assignment_date)
                    }
                    helperText={
                      formik.touched.assignment_date && formik.errors.assignment_date
                    }
                    
                  />
                </Grid>*/}
              <Grid item xs={12} sm={12} lg={12} className={classes.addBox}>
                <Autocomplete
                  id="pricingGroups"
                  value={currentBaseAccountConf.pricing_group}
                  options={pricingGroups}
                  renderInput={(param) => (
                    <TextField
                      {...param}
                      label={formatMessage({
                        id: "sharedScreen.pricingGroupId",
                      })}
                      variant="outlined"
                      size="small"
                    />
                  )}
                  getOptionLabel={(Option) => Option.code}
                  onChange={(event, pricingG) => {
                    pricingG != null &&
                      handleDataChange("pricing_group", pricingG);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12} className={classes.addBox}>
                <Autocomplete
                  id="currencies"
                  value={currentBaseAccountConf.currency}
                  options={currencies}
                  renderInput={(param) => (
                    <TextField
                      {...param}
                      label={formatMessage({ id: "sharedScreen.currencyId" })}
                      variant="outlined"
                      size="small"
                    />
                  )}
                  getOptionLabel={(Option) => Option.code}
                  //onChange={formik.handleChange}
                  onChange={(event, currency) => {
                    currency != null && handleDataChange("currency", currency);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12} className={classes.addBox}>
                <Autocomplete
                  id="countries"
                  value={currentBaseAccountConf.country}
                  options={countries}
                  renderInput={(param) => (
                    <TextField
                      {...param}
                      label={formatMessage({ id: "sharedScreen.countryId" })}
                      variant="outlined"
                      size="small"
                    />
                  )}
                  getOptionLabel={(Option) => Option.designation}
                  onChange={(event, country) => {
                    country != null && handleDataChange("country", country);
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                lg={12}
                container
                direction="row"
                className={classes.addBox}
              >
                <InputButton
                  disabled={formik.isSubmitting}
                  fullWidth
                  type="submit"
                  variant="contained"
                  color="secondary"
                >
                  <FormattedMessage id="sharedScreen.edit" />
                  {formik.isSubmitting && <CircularProgress size={30} />}
                </InputButton>
              </Grid>
              {succeed && (
                <Grid item xs={12} sm={12} lg={12}>
                  <Alert severity="success">
                    <FormattedMessage id="sharedScreen.baseAccountconfigUpdatedSuccessfully" />
                  </Alert>
                </Grid>
              )}
            </Grid>
          </Grid>
        </form>
      </Paper>
    </>
  );
};
